import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Button, Form } from 'semantic-ui-react';

import { getValue } from '_utils';
import { licensePoolPropType } from '_utils/licensePools';

import BaseDateField from '_forms/baseDate'

const ModifyLicensePoolExpiryForm = ({ licensePool, onSubmit }) => {

  const [expiry, setExpiry] = useState(licensePool.expires_on);

  const isDirty = !moment(licensePool.expires_on).isSame(moment(expiry));

  const onCancel = () => setExpiry(licensePool.expires_on);
  const onSubmitForm = () => isDirty && onSubmit({ expires_on: expiry });
  const onChange = (e, data) => setExpiry(getValue(data));

  return (
    <Form size='tiny' onSubmit={ onSubmitForm } >
      <Form.Group>
        <BaseDateField
          width={ 16 }
          name='expires_on'
          value={ moment(expiry) }
          onChange={ onChange }
          labelTxt='Expires On'
        />
      </Form.Group>
      <Button.Group>
        <Button disabled={!isDirty} onClick={ onCancel }>Cancel</Button>
        <Button.Or />
        <Button positive={isDirty} disabled={!isDirty} type="submit">Save</Button>
      </Button.Group>
    </Form>
  )
};

ModifyLicensePoolExpiryForm.propTypes = {
  licensePool: licensePoolPropType.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ModifyLicensePoolExpiryForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionLicensePoolFormExpiry.js